import { QueryClient } from 'react-query';

export const createQueryClient = () => {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: Infinity,
                retry: 0,
            },
        },
    });
};
